module.exports = __webpack_public_path__ + "img/ps-54.ba10c48c.jpg";